/**
 * @constructor
 * @param {number}                  index
 * @param {SVGWrapper}              svgGroup
 */
var LayerInfo = function(index, visible, svgGroup, name)  {
    this.index      = index;
    this.visible    = visible; //TODO: deprecated
    this.name       = name;
    this.svgGroup   = svgGroup;
};

module.exports = LayerInfo;

